import useParameterValue from '../../../../../../../services/data/hooks/useParameterValue.ts'
import TextStatisticCard from '@/shared/Analytics/TextStatisticCard'
import { IEquipment } from '../../../../../equipment.types.ts'
import formatUtils from '@/utils/format.utils.ts'

interface IProps {
  equipmentId: IEquipment['id']
}

const LiftTotalRidesStatisticCard = (props: IProps) => {
  const value = useParameterValue(props.equipmentId, 'totalTrips')

  return (
    <TextStatisticCard title="Всего поездок" loading={value.loading} width="100%" height="84px">
      <p className="text-heading-5">{value.value ? formatUtils.formatNumber(value.value) : '—'}</p>
    </TextStatisticCard>
  )
}

export default LiftTotalRidesStatisticCard
